import { Button, Col, Form, Input, Row, Select } from 'antd';
import Api from '../../../../api/Api';
import useHomeStore from '../../../../store/homeStore';
import { IInfoResult, IState } from '../../../../types/api';
import styles from '../UserProfile.module.scss';

const { Option } = Select;

interface BusinessInfoFormProps {
  statesList: IState[];
  readOnly: boolean;
  editCompanyUrl?: string;
}

export const BusinessInfoForm = ({
  statesList,
  readOnly,
  editCompanyUrl,
}: BusinessInfoFormProps) => {
  const countryList = useHomeStore((state) => state.countryList);
  const companySizeList = useHomeStore((state) => state.companySizeList);
  const segmentsList = useHomeStore((state) => state.segmentsList);

  const handleEditCompanyProfile = () => {
    if (editCompanyUrl) {
      window.open(editCompanyUrl, '_blank');
    } else if (Api.DhiSupportUrl && Api.SERVER_DOMAIN) {
      window.open(
        `${Api.DhiSupportUrl}/company/?redirecttext=MOOD&redirecturl${Api.SERVER_DOMAIN}`,
        '_blank'
      );
    }
  };

  return (
    <Col xs={24} md={24} lg={16}>
      <Row gutter={24}>
        <Col xs={24} lg={12}>
          <div className={styles.sectionHeader}>
            <div className={styles.registerTitle}>Business information</div>
            {!readOnly && (
              <Button
                type="primary"
                onClick={handleEditCompanyProfile}
                id="UserProfile-EditBusinessProfile_Button"
              >
                Edit
              </Button>
            )}
          </div>
        </Col>
      </Row>
      <Row gutter={[24, 16]}>
        <Col xs={24} lg={12}>
          <Form.Item className={styles.registerFormItem} name="company" label="Name">
            <Input id="UserProfile-Company_Input" placeholder="" disabled autoComplete="no" />
          </Form.Item>

          <Form.Item className={styles.registerFormItem} name="city" label="City">
            <Input id="UserProfile-City_Input" placeholder="" disabled autoComplete="no" />
          </Form.Item>

          <Form.Item className={styles.registerFormItem} name="zipcode" label="Zip Code">
            <Input id="UserProfile-ZipCode_Input" placeholder="" disabled autoComplete="no" />
          </Form.Item>

          <Form.Item className={styles.registerFormItem} name="countryId" label="Country">
            <Select
              id="UserProfile-Country_Select"
              showSearch
              optionFilterProp="children"
              style={{ width: '100%' }}
              disabled={true}
            >
              {countryList.map((country) => {
                return (
                  <Option key={country.id} value={country.id}>
                    {country.name}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>

          <Form.Item className={styles.registerFormItem} name="stateId" label="State">
            <Select
              id="UserProfile-State_Select"
              showSearch
              optionFilterProp="children"
              style={{ width: '100%' }}
              disabled={true}
            >
              {statesList.map((state: IState) => {
                return (
                  <Option key={state.id} value={state.id}>
                    {state.name}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>

          <Form.Item className={styles.registerFormItem} name="address1" label="Address">
            <Input id="UserProfile-Address1_Input" autoComplete="no" placeholder="" disabled />
          </Form.Item>

          <Form.Item className={styles.registerFormItem} name="address2" label="Address 2">
            <Input id="UserProfile-Address2_Input" autoComplete="no" placeholder="" disabled />
          </Form.Item>
        </Col>
        <Col xs={24} lg={12}>
          <Form.Item className={styles.registerFormItem} name="companyId" label="VAT number">
            <Input id="UserProfile-CompanyId_Input" placeholder="" disabled autoComplete="no" />
          </Form.Item>

          <Form.Item className={styles.registerFormItem} name="sizeId" label="Company size">
            <Select
              id="UserProfile-CompanySize_Select"
              showSearch
              optionFilterProp="children"
              style={{ width: '100%' }}
              open={false}
              disabled={true}
            >
              {companySizeList.map((companySize: IInfoResult) => {
                return (
                  <Option key={companySize.id} value={companySize.id}>
                    {companySize.name}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>

          <Form.Item className={styles.registerFormItem} name="segmentId" label="Company segment">
            <Select
              id="UserProfile-CompanySegment_Select"
              showSearch
              optionFilterProp="children"
              style={{ width: '100%' }}
              disabled={true}
            >
              {segmentsList.map((segmentInfo: IInfoResult) => {
                return (
                  <Option key={segmentInfo.id} value={segmentInfo.id}>
                    {segmentInfo.name}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>

          <Form.Item
            className={styles.registerFormItem}
            name="subscription"
            label="Subscription plan"
          >
            <Input id="UserProfile-Subscription_Input" autoComplete="no" placeholder="" disabled />
          </Form.Item>

          <Form.Item
            className={styles.registerFormItem}
            name="expiredDate"
            label="Subscription expiry date"
          >
            <Input id="UserProfile-ExpiredDate_Input" autoComplete="no" placeholder="" disabled />
          </Form.Item>
        </Col>
      </Row>
    </Col>
  );
};
